import { render, staticRenderFns } from "./BankDepositComponent.vue?vue&type=template&id=5843fd7e&"
import script from "./BankDepositComponent.vue?vue&type=script&lang=js&"
export * from "./BankDepositComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports